// extracted by mini-css-extract-plugin
export var body = "_mh-8";
export var button = "_mh-0";
export var closeButton = "_mh-5";
export var content = "_mh-3";
export var empty = "_mh-f";
export var grid = "_mh-c";
export var header = "_mh-4";
export var icon = "_mh-1";
export var option = "_mh-d";
export var optionSelected = "_mh-e";
export var overlay = "_mh-2";
export var searchIcon = "_mh-a";
export var searchInput = "_mh-b";
export var searchWrapper = "_mh-9";
export var title = "_mh-6";
export var visuallyHidden = "_mh-7";